import * as React from 'react';
import { isMobile } from 'react-device-detect';
import {
  ContainerProcedure,
  ButtonBack,
  SubContainer
} from '../info/components';
import Spinner from '../../../../../../components/Spinner';
import { ToggleHeader, TextTitle } from './components';
import { Block } from '../../../../../../components';
import Step from '../../../requests/UpdatePhoto/Register/components/Step';
import RegisterForm from './components/RegisterForm';
import Processing from '@/presentation/components/Processing';
import ModalConfirmation from '../../../../components/Modal/Modal';
import ConfirmationQuit from '../../../requests/UpdatePhoto/Register/components/ConfirmationQuit';
import constants from '../../../../constants';

interface CertificateType01RegisterViewProps {
  procedureSelectedInfo: any;
  selectedPeriod: any;
  handlerChangePeriod: (period: any) => void;
  handlerBackButton: () => void;
  handlerBackButtonConfirm: (accept: boolean) => void;
  handlerRegister: () => void;
  handlerRegisterAutoPeriod: () => void;
  isProcessing: boolean;
  showConfirmCancel: boolean;
}
const CertificateType01RegisterView: React.FC<
  CertificateType01RegisterViewProps
> = (props) => {
  const {
    procedureSelectedInfo,
    selectedPeriod,
    handlerChangePeriod,
    handlerBackButton,
    handlerBackButtonConfirm,
    handlerRegister,
    handlerRegisterAutoPeriod,
    isProcessing,
    showConfirmCancel
  } = props;
  const handlerCustom =
    procedureSelectedInfo?.id !==
      constants.categories.certificates.type1Ids[1] &&
    procedureSelectedInfo?.id !==
      constants.categories.certificates.type1Ids[4] &&
    procedureSelectedInfo?.id !== constants.categories.certificates.type1Ids[6]
      ? handlerRegister
      : handlerRegisterAutoPeriod;

  return (
    <ContainerProcedure>
      {!procedureSelectedInfo && <Spinner />}
      {procedureSelectedInfo && (
        <SubContainer>
          <ButtonBack onClick={handlerBackButton} />
          <ToggleHeader
            name={procedureSelectedInfo?.name}
            amount={procedureSelectedInfo?.amount}
            duration={procedureSelectedInfo?.duration}
            pin1={procedureSelectedInfo?.pin1}
          />
          <TextTitle title="Progreso" />
          <Block
            customized
            padding={isMobile ? '28px 0px 52px 8px' : '28px 0px 45px 16px'}
          >
            <Step
              name={procedureSelectedInfo?.steps[0]?.name}
              order={procedureSelectedInfo?.steps[0]?.order}
              isCurrent
            >
              <RegisterForm
                procedureId={procedureSelectedInfo?.id}
                isValid={selectedPeriod !== null}
                periods={procedureSelectedInfo?.periods?.map((p: any) => ({
                  value: p.id,
                  label: p.description
                }))}
                admission={procedureSelectedInfo?.detail}
                changePeriod={handlerChangePeriod}
                onSubmit={handlerCustom}
              />
            </Step>
            <Step
              name={procedureSelectedInfo?.steps[1]?.name}
              order={procedureSelectedInfo?.steps[1]?.order}
              disabled
              isCurrent
            />
            <Step
              name={procedureSelectedInfo?.steps[2]?.name}
              order={procedureSelectedInfo?.steps[2]?.order}
              disabled
              isLast
            />
          </Block>
          <Processing isOpen={isProcessing} />
          <ModalConfirmation
            show={showConfirmCancel}
            handleClose={() => {
              handlerBackButtonConfirm(false);
            }}
          >
            <ConfirmationQuit
              handleQuit={() => handlerBackButtonConfirm(true)}
              handleCancel={() => handlerBackButtonConfirm(false)}
            />
          </ModalConfirmation>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default CertificateType01RegisterView;
